import { useDispatch, useSelector } from 'react-redux';
import { addItemToCart, addItemToServerCart } from '../cart/cart.actions';
import { isFabric, isGarment } from '../store.utils';

const useAddToCart = () => {
  const productCustomization = useSelector(
    (state) => state.productCustomization
  );
  const dispatch = useDispatch();

  const addToCart = (product) => {
    if (isGarment(product)) {
      const item = {
        product,
        quantity: 1,
        ...productCustomization,
      };
      dispatch(addItemToCart(item));
      dispatch(addItemToServerCart(item));
    } else if (isFabric(product)) {
      const item = { product, quantity: 1, meters: product.meters };
      dispatch(addItemToCart(item));
      dispatch(addItemToServerCart(item));
    } else {
      // is generic product
      const item = { product, quantity: 1 };
      dispatch(addItemToCart(item));
      dispatch(addItemToServerCart(item));
    }
  };

  return {
    addToCart,
  };
};

export default useAddToCart;
